import { useEffect, useRef, useState } from 'react';

function getScrollParent(el: HTMLElement): HTMLElement | null {
  let node = el.parentElement;
  while (node) {
    const overflowY = getComputedStyle(node).overflowY;
    if (overflowY === 'auto' || overflowY === 'scroll') return node;
    node = node.parentElement;
  }
  return null;
}

/**
 * A 1px sentinel sits just above a `position: sticky` header. When it leaves
 * the scroller (inset by `stickyTop`), the header has engaged and is stuck.
 */
export function useIsStuck(stickyTop: number) {
  const [stuck, setStuck] = useState(false);
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;
    const root = getScrollParent(sentinel);
    if (!root) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        setStuck(!entry.isIntersecting);
      },
      {
        root,
        rootMargin: `-${stickyTop}px 0px 0px 0px`,
        threshold: 0,
      }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [stickyTop]);

  return { sentinelRef, stuck };
}
